export const MY_ROOM_FILE_KEYS = 'my_room_file_keys';
export const MY_WEBINAR_FILE_KEYS = 'my_webinar_file_keys';
